import { toast } from 'react-hot-toast';
import { profileService } from '../services';
import { ICreateBudget, ICreateProfile, ICreateSupport, IUpdateProfile } from '../@types';
import { Customer } from '../types';
const PATH = `profile`;
const BASE = `companies`;

import moment from 'moment';
export const createProfile = async (data: ICreateProfile) => {
  try {
    const res = await profileService.post('/companies', data);
    return res.data;
  } catch (e: any) {
    throw new Error(e.response?.data || e.message);
  }
};

export const getProfile = async () => {
  try {
    const res = await profileService.get(`/${BASE}/${PATH}`);
    return res.data;
  } catch (e: any) {
    throw new Error(e.response?.data || e.message);
  }
};

export const getInvoiceStats = async (start: string, end: string) => {
  let link = `/${BASE}/invoice-stats`;
  if (start) {
    link = `/${BASE}/invoice-stats?start=${start}`;
  }
  if (end) {
    link = `/${BASE}/invoice-stats?end=${end}`;
  }
  if (start && end) {
    link = `/${BASE}/invoice-stats?start=${start}&end=${end}`;
  }
  try {
    const res = await profileService.get(link);
    return res.data;
  } catch (e: any) {
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};

export const getInventoryStats = async () => {
  let link = `/${BASE}/inventory-stats`;
  try {
    const res = await profileService.get(link);
    return res.data;
  } catch (e: any) {
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};

export const getCustomerStats = async (start?: string, end?: string) => {
  let link = `/${BASE}/customer-stats`;
  if (start) {
    link = `/${BASE}/customer-stats?start=${start}`;
  }
  if (end) {
    link = `/${BASE}/customer-stats?end=${end}`;
  }
  if (start && end) {
    link = `/${BASE}/customer-stats?start=${start}&end=${end}`;
  }
  try {
    const res = await profileService.get(link);
    return res.data;
  } catch (e: any) {
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};
export const updateProfile = async (data: IUpdateProfile) => {
  try {
    const res = await profileService.patch(`/${BASE}/${PATH}`, data);
    return res.data;
  } catch (e: any) {
    throw new Error(e.response?.data || e.message);
  }
};

export const getExpenseStats = async (start?: string, end?: string) => {
  const currentDate = moment();
  const defaultStart = moment(currentDate).startOf('month').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
  const defaultEnd = moment(currentDate).endOf('month').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');

  let link = `/${BASE}/expenses-stats`;
  if (start) {
    link = `/${BASE}/expenses-stats?start=${start}`;
  } else {
    link = `/${BASE}/expenses-stats?start=${defaultStart}`;
  }
  if (end) {
    link = `${link}&end=${end}`;
  } else {
    link = `${link}&end=${defaultEnd}`;
  }

  try {
    const res = await profileService.get(link);
    return res.data;
  } catch (e: any) {
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};

export const getBudgetHistory = async (startMonthYear?: string, endMonthYear?: string) => {
  let link = '/budgets';

  if (startMonthYear && endMonthYear) {
    link += `?startMonthYear=${startMonthYear}&endMonthYear=${endMonthYear}`;
  } else if (startMonthYear) {
    link += `?startMonthYear=${startMonthYear}`;
  } else if (endMonthYear) {
    link += `?endMonthYear=${endMonthYear}`;
  }

  try {
    const res = await profileService.get(link);
    return res.data;
  } catch (e: any) {
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};

export const updateUserSettings = async ({ firstLogin }: { firstLogin: boolean }) => {
  const settings = {
    firstLogin: firstLogin,
  };

  try {
    const res = await profileService.patch(`/${BASE}/settings`, settings);
    return res.data;
  } catch (e: any) {
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};

export const createBudget = async (data: { monthYear: string; allocatedBudget: number }) => {
  try {
    const res = await profileService.post('/budgets', data);
    return res.data;
  } catch (e: any) {
    throw new Error(e.response?.data || e.message);
  }
};

export const updateBudget = async (data: { monthYear: string; allocatedBudget: number }) => {
  try {
    const res = await profileService.put(`/budgets`, data);
    return res.data;
  } catch (e: any) {
    console.log(e.response.data);
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};

export const createSupport = async (data: ICreateSupport) => {
  try {
    const res = await profileService.post('/support', data);
    return res.data;
  } catch (e: any) {
    throw new Error(e.response?.data || e.message);
  }
};
